<template>
  <base-dialog
    :action="onAction"
    :action-name="'Select'"
    :close="onClose"
    :title="'Select timezone'"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
      <v-container>
        <v-row v-if="!isLoading">
          <v-col cols="1" />
          <v-col cols="10">
            <v-select
              v-model="selectedTimezone"
              outlined
              dense
              label="Timezones"
              :items="items"
              item-value="id"
              item-text="label"
            />
          </v-col>
        </v-row>

        <v-row v-if="isLoading">
          <v-col cols="12">
            <v-row
              align="center"
              justify="center"
              style="height: 250px;"
            >
              <v-progress-circular
                :size="100"
                :width="5"
                color="primary"
                indeterminate
              />
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </base-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BaseDialog from "../Common/BaseDialog"

export default {
  components: { BaseDialog },
  props: {
    initTimezone: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isLoading: false,
      selectedTimezone: this.initTimezone,
    }
  },
  computed: {
    ...mapGetters([ 'getTimezones' ]),
    items() {
      return this.getTimezones
        .map(timezone => {
          return {
            id: timezone.zone,
            label: `GMT${timezone.offset} - ${timezone.name}`
          }
        })
    }
  },
  watch: {
    initTimezone() {
      this.selectedTimezone = this.initTimezone
    }
  },
  created() {
    this.isLoading = true
    this.listTimezones({})
      .finally(() => {
        this.isLoading = false
      })
  },
  methods: {
    ...mapActions([ 'listTimezones' ]),
    onClose() {
      this.$emit('close')
    },
    async onAction() {
      this.$emit('action', this.selectedTimezone)
    }
  }
}
</script>
